// extracted by mini-css-extract-plugin
export default {"addToCartControl":"v3-z","giftCard":"w3-z","btnContainer":"x3-z","cartButton":"y3-z","disabled":"z3-z","stockMessage":"A3-z"};